import { currecyFormat } from '@/mixins/currency'

import getNested from '@/utils/getNested'

export default {
  methods: {
    getValue(path) {
      return getNested(this.$currentApp, path) || 0
    },
    getFormattedValue(value) {
      return currecyFormat(parseFloat(value), { style: 'currency' })
    },
  },
}
